import { HistoryEvent } from '../../../../../services/eventingApi';

const replayAttributes = (event: HistoryEvent, target: string) => ({
  MessageAttributes: {
    eventId: event.message.eventId,
    eventType: event.message.eventType,
    occurredAt: event.message.occurredAt,
    correlationId: event.message.correlationId,
    causationId: event.message.causationId,
    delivery: 'replay',
    target,
    ...(event.message.payloadRef ? { payloadRef: event.message.payloadRef } : {}),
    aggregateId: event.aggregate.aggregateId,
    aggregateVersion: event.aggregate.aggregateVersion,
  },
  Message: '(corpo original do histórico)',
});

const ReplayPreview = ({ event, target }: { event: HistoryEvent; target: string }) => (
  <pre className="max-h-56 overflow-auto rounded-md bg-gray-900 p-3 text-xs text-green-200">{JSON.stringify(replayAttributes(event, target), null, 2)}</pre>
);

export default ReplayPreview;
